/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.31/esri/copyright.txt for details.
*/
const o=Symbol("Accessor-beforeDestroy");export{o as beforeDestroySymbol};
